import { render, staticRenderFns } from "./workerscenter.vue?vue&type=template&id=893acf98"
import script from "./workerscenter.vue?vue&type=script&lang=js"
export * from "./workerscenter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports